import React, {useContext} from 'react';
import { Typography, Grow } from '@material-ui/core';
import { MailRounded, GetApp } from '@material-ui/icons';
import { LanguageContext } from '../../App'

export const Footer = () => {
	const { language } = useContext(LanguageContext) 
	return (
		<Grow in={true} timeout={1000}>
			<div>
				<Typography variant="h4" color="secondary" align="center">
					{language === 'spanish' ? 'TAMBIÉN PODÉS CONTACTARTE CONMIGO VÍA MAIL ' : 'YOU CAN ALSO CONTACT ME BY EMAIL '}
					<a href="mailto: nicolascappellabb@gmail.com">
						{' '}
						<MailRounded color="secondary" />
					</a>
				</Typography>
				<Typography variant="h4" color="secondary" align="center">
					{language === 'spanish' ? 'Y VISUALIZAR MI CV PARA SABER LAS TECNOLOGÍAS QUE MANEJO ' : 'AND VISUALIZE MY CV TO KNOW THE TECHONLOGIES I MANAGE '}
					<a href="https://firebasestorage.googleapis.com/v0/b/portfolio-nicolas.appspot.com/o/Nicolas-Cappella.pdf?alt=media&token=e475cad6-27c7-4b7c-bfa6-80b2eb4b79a7" target="_blank" rel="noreferrer">	<GetApp color="secondary" />
				</a></Typography>
			</div>
		</Grow>
	);
};
